import { TelecomWaitingRoomEntryStatus } from '@montugroup/pms-api-contracts';

const CONSULT_STATUS_MAP: Partial<Record<TelecomWaitingRoomEntryStatus, string>> = {
  [TelecomWaitingRoomEntryStatus.Waiting]: 'Patient is in waiting room',
  [TelecomWaitingRoomEntryStatus.InConsult]: 'Patient is in call',
};

export { CONSULT_STATUS_MAP };
